import React, { useState } from 'react';
import { Card, Image, Spinner } from 'react-bootstrap';
import {  AxiosInstance } from '../../../utils/RequestMethods';

import * as _ from 'lodash'

import ButtonLoading from '../../ButtonLoading/ButtonLoading';
import config from '../../../constants/config';
import images from '../../../constants/images';
import { PaymentCardT } from '../../../types/Payments';

import { parseFloatTotal } from '../../../utils/utilsT';
import { LineItemTransactionT, TransactionT } from '../../../types/TransactionT';
import WithSkeleton from '../../WithSkeleton';
import { Button, Typography, Box, Grid, Backdrop, CircularProgress, Collapse, Alert } from '@mui/material';
import toast from 'react-hot-toast';
import { defaultOptionsToast, ToastMessage } from '../../../constants/defaultOptionsToast';

const imagesCreditCard = {
    "VISA": images.VISA,
    "MASTERCARD": images.MASTERCARD,
    'AMEX': images.AMEX,
    'DISCOVER': images.DISCOVER,
    'DEFAULT': images.DEFAULT
}


export type ICreditCardCheckoutProps = {
    item: PaymentCardT
    userId?: number
    productId: number // example jobId
    productType: string // example jobs
    paymentItems: Array<LineItemTransactionT>
    onCompleteProcessing(transaction: TransactionT): void

    stripe: any

    customButtonProps?: any
    titleButton?: string
    back?(): void
    onChangeProcessing?(processing: boolean): void
    onDisplayConfirmUi?(): void
}

const ButtonChargeCard: React.FC<ICreditCardCheckoutProps> = (props) => {

    // const [clientSecret, setClientSecret] = React.useState(null);
    // const [paymentMethod, setPaymentMethod] = React.useState(null);

    // const [errorMessage, setErrorMessage] = React.useState(null);
    const [transactionId, setTransactionId] = React.useState(null);
    const [processing, setProcessing] = React.useState(false);
    const [requiresCapture, setRequiresCapture] = React.useState(null);

    const [paymentIntentId, setPaymentIntentId] = React.useState(null);

    const [amount, setAmount] = React.useState(0);
    const [processingCapture, setProcessingCapture] = React.useState(false);
    const [paymentSuccessfully, setPaymentSuccessfully] = React.useState(false);

    const [openAlert, setOpenAlert] = React.useState(false);

    React.useEffect(() => {
        const totalAmount = props.paymentItems.reduce((price, item, index) => {
            return Number(price) + Number(item.amount)
        }, 0)


        setAmount(totalAmount)
    }, [props.paymentItems]);



    React.useEffect(() => {
        if (props.onChangeProcessing) {
            props.onChangeProcessing(processing)
        }
    }, [processing]);


    React.useEffect(() => {
        if (paymentIntentId && props.onDisplayConfirmUi) {
            props.onDisplayConfirmUi()
        }
    }, [paymentIntentId]);



    React.useEffect(() => {
        if (transactionId && paymentIntentId && !processingCapture) {
            paymentCapture()
        }
    }, [paymentIntentId, transactionId]);
    /**
     *
     * @param paymentIntentId
     * @returns
     */
    const chargeCard = async (paymentIntentId: string | null = null): Promise<string> => {


        try {
            let params = {
                // jobId: jobId,
                userId: props.userId,
                productId: props.productId,
                productType: props.productType,
                lineItems: props.paymentItems
            }
            let res = await AxiosInstance.post(`${config.url.transactions}/checkout/charge/${props.item.id}`, params)
            if (res && res.data) {
                console.log("chargeCard", res.data)
                if (_.has(res.data, "transaction.id")) {
                    setTransactionId(res.data.transaction.id)
                }


                if (res.data.requiresAction == true) {

                    const paymentIntent = await handleAuthenticationChallenge(res.data.clientSecret)
                    console.log("paymentIntent", paymentIntent)
                    if (paymentIntent.status == "requires_confirmation" || paymentIntent.status == "requires_capture") {
                        // confirm before captuere
                        const confirm = await confirmPayment(paymentIntent.id)
                        if (confirm) {
                            setPaymentIntentId(paymentIntent.id)
                        }

                        return "Payment captured."
                    } else {
                        throw new Error(paymentIntent.message);

                    }
                } else {
                    setProcessing(false)
                    if ((res.data.status == "requires_confirmation" || res.data.status == "requires_capture") && res.data.paymentIntentId) {
                        setPaymentIntentId(res.data.paymentIntentId)
                        return "Payment captured."
                    } else if (res.data.status == "succeeded" && res.data.paymentIntentId) {
                        // const confirm = await confirmPayment(res.data.paymentIntentId)
                        // console.log("confirm", confirm)
                    
                        return "Payment captured."
                    }
                }


                throw new Error("Unknown error occurred");
            }


        } catch (error) {

            // toastShowMessage(error.message, false)
            throw new Error(error);
        }
    }




    /**
    *
    * @param param
    * @returns
    */
    const handleAuthenticationChallenge = async (clientSecret: number): Promise<any> => {
        let response = null
        try {
            console.log('Calling stripe.authenticatePaymentIntent()')

            const { paymentIntent, error } = await await props.stripe.handleCardAction(clientSecret)
            console.log('stripe.authenticatePaymentIntent()', paymentIntent)
            if (error) {
                setProcessing(false);
                // setErrorMessage(error.message)
                // toastShowMessage(error.message, false)
                throw new Error(error.message);
            }


            if (paymentIntent.status === 'requires_payment_method') {
                response = {
                    message: 'Authentication failed, a new PaymentMethod needs to be attached.',
                    status: paymentIntent.status,
                    id: paymentIntent.id,
                }
            } else if (paymentIntent.status === 'requires_confirmation') {
                response = {
                    message: 'Authentication passed, requires confirmation (server-side)',
                    status: paymentIntent.status,
                    id: paymentIntent.id,
                }
            } else {
                response = {
                    message: 'Unexpected.',
                    status: paymentIntent.status,
                    raw: paymentIntent,
                    id: null,
                }
            }
        } catch (error) {
            console.log("handleAuthenticationChallenge->error", error)
            throw new Error(error.message);
        }

        return response
    }


    /**
     *
     * @param paymentIntentId
     * @returns
     */
    const confirmPayment = async (varPaymentIntentId: string, amountToCapture: number | null = null): Promise<TransactionT> => {
        try {
            let params = {
                userId: props.userId,
                paymentIntentId: varPaymentIntentId,
                lineItems: props.paymentItems
            }
            // params['amountToCapture'] = props.amount
            if (amountToCapture) {
                params['amountToCapture'] = amount
            }
            console.log("confirmPayment", params)
            let res = await AxiosInstance.post(`${config.url.transactions}/checkout/charge/${props.item.id}/confirm`, params)
            console.log("confirmPayment->res", res)
            if (res && res.data && res.data.transaction) {
                console.log("confirmPayment->transaction", res.data.transaction)
                return res.data.transaction
            }

        } catch (error) {
            throw error
        }

    }
    /**
     *
     * @param transactionId
      * @returns
    */
    const cancelTransaction = async (transactionId: string): Promise<string> => {
        setProcessing(true)
        try {
            let params = {
                userId: props.userId,
                transactionId: transactionId,
            }
            let options={
              data:params
            }
            let res = await AxiosInstance.delete(`${config.url.transactions}/checkout/charge/${props.item.id}`, options)
            setProcessing(false)
            if (res && res.data) {

                const transaction = res.data.transaction
                setTimeout(() => {
                    rest()
                    // props.onCompleteProcessing(transaction)
                    if (props.back) {
                        props.back()
                    }
                }, 1000);
                return "Transaction canceled."
            }

        } catch (error) {
            setProcessing(false)
            throw new Error(error);
        }
        return ""
    }




    /**
     *
     * @param e
     * @returns
     */
    const confirmClick = async (e): Promise<string> => {
        return await confirm(paymentIntentId, amount)
    }


    /**
     *
     * @returns
     */
    const paymentCapture = async (): Promise<string> => {
        setProcessingCapture(true)
        try {
            const res = await confirm(paymentIntentId, amount)
            setOpenAlert(true)
            setPaymentSuccessfully(true)
            setProcessingCapture(false)
            toast.success((t) => (
                <ToastMessage message={res} t={t} />
            ), defaultOptionsToast);
            return res
        } catch (error) {
            setProcessingCapture(false)
            const msgError = _.has(error, "message") ? `${error.message}` : `${error}`
            toast.error((t) => (
                <ToastMessage message={msgError} t={t} />
            ), defaultOptionsToast);
        }
    }


    const getMsgPaymentSuccessfully = () => {
        return `$${parseFloatTotal(amount)} Payment captured.`
    }
    /**
     * use twice
     * confirm authenticate payment
     * captuer
     * @returns
     */
    const confirm = async (paymentIntentId, amount): Promise<string> => {
        setProcessing(true)
        // console.log("confirm->start", paymentIntentId)
        try {
            const transaction = await confirmPayment(paymentIntentId, amount)
            // console.log("confirm", transaction)
            if (transaction) {
                setTimeout(() => {
                    rest()
                    props.onCompleteProcessing(transaction)
                    if (props.back) {
                        props.back()
                    }
                }, 3000);
                const message = getMsgPaymentSuccessfully()
                return message
            }
            setProcessing(false)
        } catch (error) {
            setProcessing(false)

            throw error
        }
    }



    const rest = () => {
        console.log("rest")
        setOpenAlert(false)
        setPaymentIntentId(null)
        setTransactionId(null)
        setPaymentSuccessfully(false)
    }


    /**
     *
     * @returns
     */
    const processingComponent = () => {
        return (
            <div style={{}}>
                <Typography><Spinner animation="border" size="sm" /> Processing...</Typography>
            </div>
        )
    }

    const renderButtonConfirm = () => {
        return (

            <Grid container spacing={2}>
                <Grid item xs={12}>

                    <ButtonLoading
                        // disabled={processing ? true : null}
                        customButton={Button}

                        customButtonProps={{
                            variant: "contained",
                            color: "success",
                            fullWidth: true,

                        }}
                        onClickFetching={confirmClick}
                        processingComponent={processingComponent()}>Confirm Payment</ButtonLoading>
                </Grid>
                <Grid item xs={12}>

                    {transactionId && <ButtonLoading
                        disabled={processing ? true : null}
                        customButton={Button}
                        customButtonProps={{
                            variant: "outlined",
                            // size:"medium" ,
                            // color: "error",
                            fullWidth: true,
                        }}
                        onClickFetching={async (): Promise<string> => {
                            return await cancelTransaction(transactionId)
                        }}
                        processingComponent={processingComponent()}>Cancel</ButtonLoading>}
                </Grid>
            </Grid>

        )
    }


    let customButtonProps = {}

    if (props.customButtonProps) {
        customButtonProps = props.customButtonProps || {}
    }

    // console.log("customButtonProps", customButtonProps)
    // const CustomButton = props.customButton
    return (
        <div className="d-flex flex-column mt-1  " style={{}}>

            <Collapse in={openAlert} className="mt-2">
                <Alert
                    severity={"success"}
                    sx={{ mb: 2 }} >

                    {paymentSuccessfully && openAlert && getMsgPaymentSuccessfully()}
                </Alert>
            </Collapse>

            {!paymentSuccessfully && <Box width="100%">
                <ButtonLoading
                    bootstrap={false}
                    noShowResultMessageSuccess
                    // variant="contained"
                    customButton={Button}
                    // noShowResultMessageSuccess
                    customButtonProps={customButtonProps}

                    // @ts-ignore
                    disabled={(processing || processingCapture) || (customButtonProps && _.has(customButtonProps, 'disabled') && !_.isNil(customButtonProps.disabled))}
                    onClickFetching={async (e): Promise<string> => {
                        e.preventDefault()
                        setProcessing(true)
                        try {

                            let res = await chargeCard()
                            console.log("res->Payment", res)
                            setProcessing(false)
                            if (res) {
                                return "Payment captured."
                            }
                        } catch (error) {
                            setProcessing(false)
                            throw error
                        }


                    }}
                    processingComponent={processingComponent()}
                >
                    {(processing || processingCapture) ? <> {processingComponent()}</> : <Typography fontWeight="bold" color="#fff">{props.titleButton ? props.titleButton : `Charge`}
                    </Typography>}   </ButtonLoading>
            </Box>}


            {/* {(paymentIntentId) && renderButtonConfirm()} */}


        </div>
    );
}


export { ButtonChargeCard }

